var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('loading'):(!_vm.form)?_c('not-found'):(!_vm.hasAuthorize.getById)?_c('no-auth'):_c('div',[_c('Result',{attrs:{"isDetail":true,"form":_vm.form,"result":_vm.result,"is-detail":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }